/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";
import Snackbar from "@mui/material/Snackbar";
import TablePagination from "@mui/material/TablePagination";
import EditIcon1 from "@mui/icons-material/EditOff";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Typography,
  Button,
  TableContainer,
  TableFooter,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Alert,
} from "@material-ui/core";
import Grid from "@mui/material/Grid";
import Loader from "react-loader-spinner";
import { makeStyles } from "@mui/styles";
import { URL } from "../../utils/factory";
import moment from "moment";

const axios = require("axios");

const useStyles = makeStyles({
  root: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const styletable = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1350,
  bgcolor: "white",
  border: "2px solid #fff",
  boxShadow: 24,
  p: 4,
};

const istyle = {
  color: "red",
};

const InvoiceDetailResult = ({
  customers,
  flagstatus,
  fromdate,
  todate,
  datesearch,
  loaderflag,
  exportlist,
  handleExportGrid,
  exportflag,
  handleExportGridTwo,
  exportlisttwo,
  exportflagver,
  exportflagverCSV,
  handelCsvButon,
  invoicelistexportcsv,
  handleViewInvoice,
  stateData,
  ...rest
}) => {
  const [invoicelist, setInvoicelList] = useState([]);

  const [loaderstate, setLoaderstate] = useState(false);

  const [invremarks, setInvRemarks] = useState("");

  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

  const [openunchecked, setOpenUnchecked] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [page, setPage] = useState(0);

  const [commentDate, setCommentDate] = useState("");

  const [responseForComment, setResponseForComment] = useState([]);

  const [sneakOpenFrComment, setSneakOpenFrComment] = useState(false);

  const [invoiceStatus, setInvoiceStatus] = useState("");

  const [invoiceAmount, setInvoiceAmount] = useState("");

  const [invoiceDate, setInvoiceDate] = useState("");

  const [openEditFirst, setOpenEditFirst] = useState(false);

  const [editInvoiceData, setEditInvoiceData] = useState("");

  const [deliveryEditData, setDeliveryEditData] = useState([]);

  const [editInvoiceDate, setChangeDripdownValue] = useState("");

  const [dropDownData, setDropDownData] = useState(null);

  const [insertPrice, setInsertPrice] = useState("");

  const [sneakOpen, setSneakOpen] = useState(false);

  const [sneakBarCommentMessage, setSneakBarCommentMessage] = useState("");

  const [errormsg, setErrorMsg] = useState(false);

  const [errorMsgForComment, setErrorMsgForComment] = useState(false);

  const [singleInvoiceId, setSingleInvoiceId] = useState("");

  const [invreason, setInvreason] = useState("");

  const [selectedCustomerDate, setSelectedCustomerDate] = useState("");

  const [allInvoiceId, setAllInvoiceId] = useState([]);

  const [settlemntSno, setSettlemntSno] = useState("");

  const [openTipRunPopup, setOpenTipRunPopup] = useState(false);

  const [open, setOpen] = useState(false);

  const [mainPoupDiv, setMainPoupDiv] = useState(false);

  const [addExtraCharges, setAddExtraCharges] = useState({
    poupType: null,
    amt: 0,
    cmt: "",
  });

  const handleChangeselect = (event) => {
    const data = event.target.value;
    setChangeDripdownValue(event.target.value);
    if (data === 0) {
      setDropDownData("Truck Hire(4T)");
    }
    if (data === 1) {
      setDropDownData("Truck Hire(6T)");
    }
    if (data === 2) {
      setDropDownData("Truck Hire(10T)");
    }
    if (data === 3) {
      setDropDownData("Truck Hire(Van)");
    }
    if (data === 4) {
      setDropDownData("Labour Hire");
    }
    if (data === 5) {
      setDropDownData("Other");
    }
    if (data === 6) {
      setDropDownData("Cancelling");
    }
  };

  const handleInsertPrice = (event) => {
    const regularExpression = /^\d*\.?\d*$/;
    if (
      event.target.value === "" ||
      regularExpression.test(event.target.value)
    ) {
      setInsertPrice(event.target.value);
    }
  };

  const handleOnOkay = () => {
    setOpenEditFirst(false);
    handleViewInvoice(stateData);
    setDeliveryEditData([]);
    setResponseForComment([]);
  };

  const handleClose = () => {
    // window.location.reload(false);
    setOpenEditFirst(false);
    // handleViewInvoice();
    // setDeliveryEditData([]);
    // setResponseForComment([]);
  };

  const handleCloseCommentSneakbar = () => {
    setSneakOpenFrComment(false);
  };

  const handleReasonChange = (event) => {
    setInvreason(event.target.value);
  };

  useEffect(async () => {
    if (customers.length > 0) {
      setInvoicelList(customers);

      setRowsPerPage(20);
      setPage(0);
    } else {
      setInvoicelList([]);
    }
  }, [customers, loaderflag]);

  useEffect(() => {
    setLoaderstate(loaderflag);
  }, [loaderflag]);

  const handleRemarksChange = (event) => {
    setInvRemarks(event.target.value);
  };

  const [newAmount, setNewAmount] = useState("");
  const [oldAmount, setOldAmount] = useState("");
  const [invNumber, setInvNumber] = useState("");
  const [settlementId, setSettlementId] = useState("");
  const [snotrId, setSnotrId] = useState("");

  const handleAmount = (event) => {
    const regularExpression = /^\d*\.?\d*$/;

    if (
      event.target.value === "" ||
      regularExpression.test(event.target.value)
    ) {
      setNewAmount(event.target.value);
    } else {
      setNewAmount("");
    }
  };

  const handleCloseAmount = () => {
    setOpen(false);
    setErrorMessage("");
    setOldAmount("");
    setNewAmount("");
    setInvNumber("");
    setSettlementId("");
    setSnotrId("");
  };

  const handleOpen = (event, id, type) => {
    setErrorMessage("");
    setOldAmount(id.Amount);
    setNewAmount(id.Amount);
    setInvNumber(id.InvoiceNo);
    setSettlementId(id.settlementid);
    setSnotrId(id.SNOTR);
    if (type === "remarks") setOpen(true);
  };

  const [errorMessage, setErrorMessage] = useState("");

  const handleSaveAmount = () => {
    const clientId = localStorage.getItem("tranuserid");

    console.log(":::::::::::::::::::::::::::::::::::::::::::::::::::::::::");

    try {
      if (newAmount.length == "") {
        setErrorMessage("Please Enter Amount");
      }
      if (oldAmount == newAmount) {
        setErrorMessage("Please change the amount");
      } else {
        axios
          .post(`${URL}sTranseditprice`, {
            invoiceno: invNumber,
            qtype: "1",
            qtype1: "5",
            settlementid: settlementId,
            Amount: newAmount,
            sno: snotrId,
            userid: clientId,
            Comment: `The Amount has been changed from  ${oldAmount} to ${newAmount} on  ${moment().format(
              "L"
            )}`,
          })
          .then((response) => {
            console.log("hello i am herer", response.data.d);
            setErrorMessage("Amount Updated Successfully");
            setInvNumber("");
            setSettlementId("");
            setSnotrId("");
            handleViewInvoice();
          })
          .catch((error) => {
            console.log("API error", error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseUnchecked = () => {
    setOpenUnchecked(false);
    setErrorMsg(false);
  };

  const handleOpenTipRunPopup = (type) => {
    setAddExtraCharges({ ...addExtraCharges, poupType: type });
    setOpenTipRunPopup(true);
  };

  const handleAddExtraChargePopup = () => {
    setMainPoupDiv(true);
  };

  const handleAmountChange = (event) => {
    const value = event.target.value;

    if (/^\d*\.?\d*$/.test(value)) {
      setAddExtraCharges({
        ...addExtraCharges,
        amt: value,
      });
      setErrorMsg(false);
    } else {
      setErrorMsg(true);
    }
  };

  const handleCloseAddExtraChargePopup = (e) => {
    setOpenTipRunPopup(false);
    setErrorMsg(false);
    setErrorMsgForComment(false);
  };

  const handleCloseMainPoupDiv = () => {
    setMainPoupDiv(false);
  };

  const handleAddExtraCharges = async () => {
    setOpenTipRunPopup(false);
    setMainPoupDiv(false);

    let remarks = addExtraCharges.cmt.trim();

    if (addExtraCharges.amt == 0) {
      setErrorMsg(true);
      return;
    }
    if (remarks == "") {
      setErrorMsgForComment(true);
      return;
    }

    const clientid = localStorage.getItem("tranuserid");
    const value = localStorage.getItem("InvoiceSno");
    try {
      axios
        .post(`${URL}SetAddExtraCharge`, {
          Userid: clientid,
          Settleid: value,
          qtype: "10",
          Description:
            addExtraCharges.poupType == 1
              ? "tip run"
              : addExtraCharges.poupType == 2
              ? "line haul fee"
              : "other",
          Amount: addExtraCharges.amt,
          Commentdesc: remarks,
          createdby: clientid,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          if (response.status == 200) {
            handleViewInvoice();
            setOpenTipRunPopup(false);
            setMainPoupDiv(false);
            setErrorMsg(false);
            setErrorMsgForComment(false);
            setAddExtraCharges({
              poupType: null,
              amt: 0,
              cmt: "",
            });
          }
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
    // }
  };

  const handleRemarks = () => {
    const clientId = localStorage.getItem("tranuserid");
    let comm = invremarks && invremarks.trim();
    if (comm === "") {
      setSneakOpenFrComment(true);
      setSneakBarCommentMessage("Please add the comment");
    } else {
      try {
        axios
          .post(`${URL}sExtraComment`, {
            invoiceno: editInvoiceData && editInvoiceData,
            description: comm,
            qtype: 5,
            ddate: commentDate,
            Userid: clientId,
            Sno: settlemntSno && settlemntSno,

            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
            },
          })
          .then((response) => {
            setSneakOpenFrComment(true);
            setSneakBarCommentMessage("Comment saved successfully");
            handleComments(editInvoiceData, settlemntSno);
            setCommentDate("");
            setInvRemarks("");
          })
          .catch((error) => {
            console.log("API error", error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    let sno;
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map(
        (customer) => customer.InvoiceNo
      );
      sno = invoicelist.map((customer) => customer.SNOTR);
      setAllInvoiceId(sno);
      setSelectedCustomerDate("");
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (invoicelist[z].InvoiceNo === newSelectedCustomerIds[i]) {
            invoicelist[z].Itd_IsTransBooked = "Booked";
            invoicelist[z].confirmnot = "Yes";
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      setSelectedCustomerIds(newSelectedCustomerIds);
      setAllInvoiceId(sno);
      for (let z = 0; z < invoicelist.length; z++) {
        invoicelist[z].Itd_IsTransBooked = invoicelist[z].Itd_IsTransBookedold;
        invoicelist[z].confirmnot = invoicelist[z].confirmnotold;
      }
    }
  };

  const handleSelectSingle = (event, invoiceidsingle, sno) => {
    let newSelectedCustomerIds;
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map(
        (customer) => customer.InvoiceNo
      );
      setSelectedCustomerIds(newSelectedCustomerIds);
      setAllInvoiceId([]);
      setSelectedCustomerDate(sno);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (
            // eslint-disable-next-line operator-linebreak
            invoicelist[z].InvoiceNo === newSelectedCustomerIds[i] &&
            invoicelist[z].SNOTR === sno
          ) {
            invoicelist[z].confirmnot = "Yes";
            invoicelist[z].Itd_IsTransBooked = "Booked";
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      setSelectedCustomerIds(newSelectedCustomerIds);
      setSelectedCustomerDate(sno);
      for (let z = 0; z < invoicelist.length; z++) {
        if (invoicelist[z].SNOTR === sno) {
          // eslint-disable-next-line operator-linebreak
          invoicelist[z].Itd_IsTransBooked =
            invoicelist[z].Itd_IsTransBookedold;
          invoicelist[z].confirmnot = invoicelist[z].chkTransBookedold;
        }
      }
    }
  };

  const handleUncheckedSingleFinal = (event, invoiceidsingle) => {
    // eslint-disable-next-line prefer-const
    let newSelectedCustomerIds = invoicelist.map(
      (customer) => customer.InvoiceNo
    );
    setSelectedCustomerIds(newSelectedCustomerIds);
    for (let i = 0; i < newSelectedCustomerIds.length; i++) {
      for (let z = 0; z < invoicelist.length; z++) {
        if (
          // eslint-disable-next-line operator-linebreak
          invoicelist[z].InvoiceNo === newSelectedCustomerIds[i] &&
          invoicelist[z].InvoiceNo === invoiceidsingle
        ) {
          invoicelist[z].Itd_IsTransBooked = "Pending";
          invoicelist[z].confirmnot = "No";
        }
      }
    }
  };

  const handleUncheckedSingle = (event, invoiceidsingle, sno) => {
    setSingleInvoiceId(invoiceidsingle);
    setSelectedCustomerDate(sno);
    setOpenUnchecked(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCloseSneakBar = () => {
    setSneakOpen(false);
  };

  const handleComments = (inv, sno) => {
    const clientId = localStorage.getItem("tranuserid");
    setResponseForComment([]);
    try {
      axios
        .post(`${URL}sExtraComment`, {
          invoiceno: inv,
          description: "",
          qtype: 6,
          ddate: "",
          Sno: sno,
          Userid: clientId,

          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          console.log("hello i am herer", response.data.d);
          setResponseForComment(JSON.parse(response.data.d));
          setInvRemarks("");
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeliveryListData = async (invoicedata, sno) => {
    setDeliveryEditData([]);
    try {
      axios
        .post(`${URL}ViewExtraCharge`, {
          invoiceno: invoicedata && invoicedata ? invoicedata : editInvoiceData,
          Sno: sno ? sno : settlemntSno && settlemntSno,
          qtype: "2",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          if (response.data.d !== "") {
            const responseData = JSON.parse(response.data.d);
            setDeliveryEditData(responseData);
          } else setDeliveryEditData([]);
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteData = (data) => {
    const value = localStorage.getItem("InvoiceSno");
    try {
      axios
        .post(`${URL}DeleteExtraCharge`, {
          invoiceno: editInvoiceData && editInvoiceData,
          qtype: "4",
          uniq_id_ec: data.sno,
          Sno: settlemntSno && settlemntSno,
          settlementid: value,
          ddate: data.Column1,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then(() => {
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (errorMessage) {
      console.log("Error message in delete method", errorMessage);
    }
  };

  const handleInserNewData = async () => {
    const value = localStorage.getItem("InvoiceSno");
    if (editInvoiceDate === "") {
      //   setSneakOpen(true);
      //   setSneakBarMessage('Please select Dropdown value');
    } else if (insertPrice === "") {
      //   setSneakOpen(true);
      //   setSneakBarMessage('Please enter amount');
    } else {
      axios
        .post(`${URL}sExtraCharge`, {
          invoiceno: editInvoiceData,
          description: dropDownData,
          amount: insertPrice,
          ddate: invoiceDate && invoiceDate,
          code: editInvoiceDate,
          uniq_id_ec: "",
          qtype: "1",
          settlementid: value,
          Sno: settlemntSno && settlemntSno,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then(() => {
          setInsertPrice("");
          setChangeDripdownValue("");
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log("API error", error);
        });
    }
  };

  const handleOpenEdit = (inv, date, amount, status, sno) => {
    setInvoiceStatus(status);
    setSettlemntSno(sno);
    setInvoiceAmount(amount);
    setInvoiceDate(date);
    handleComments(inv, sno);
    setOpenEditFirst(true);
    setEditInvoiceData(inv);
    handleDeliveryListData(inv, sno);
  };

  const handleConfirmEditExcel = (data) => {
    const value = localStorage.getItem("InvoiceSno");

    try {
      axios
        .post(`${URL}sTrnasinvoivemain`, {
          invoiceno: data.SNOTR,
          qtype: "2",
          settlementid: value,
          Date1: data.DeliveryDate,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then(() => {
          const value = localStorage.getItem("InvoiceSno");
          setSneakOpenFrComment(true);
          setSneakBarCommentMessage("Invoice confirmed successfully");
          handleViewInvoice(stateData);
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (errorMessage) {
      console.log("Error inside handle save invoice", errorMessage);
    }
  };
  // Update All status by checkbox

  const handleUpdateSelected = () => {
    const value = localStorage.getItem("InvoiceSno");
    setLoaderstate(true);
    let allSno = allInvoiceId && allInvoiceId.toString();
    let selectedinv = "";
    for (let z = 0; z < invoicelist.length; z++) {
      if (invoicelist[z].confirmnot === "Yes") {
        selectedinv += "," + invoicelist[z].InvoiceNo;
      }
    }
    try {
      axios
        .post(`${URL}sTrnasupdate`, {
          qtype: "9",
          invoiceswith:
            selectedCustomerDate && selectedCustomerDate > 0
              ? selectedCustomerDate
              : allSno,
          settlementid: value,
          status: stateData ? stateData : "",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
          },
        })
        .then((response) => {
          const userdata = eval(response.data.d);
          setInvoicelList(userdata);
          setLoaderstate(false);
        })
        .catch((error) => {
          console.log("API error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // Update All status by checkbox

  // Unckeck Reason Model start
  const handleReason = () => {
    const comments = invreason && invreason.trim();
    const settlementId = localStorage.getItem("InvoiceSno");
    const clientId = localStorage.getItem("tranuserid");
    try {
      if (comments === "") {
        setErrorMsg(true);
      } else {
        setLoaderstate(true);
        setInvoicelList([]);
        setErrorMsg(false);
        setOpenUnchecked(false);
        axios
          .post(`${URL}sTrnanundo`, {
            InvoiceNo: selectedCustomerDate,
            qtype: "8",
            status: stateData ? stateData : "",
            settlementid: settlementId,
            description: comments,
            Userid: clientId,

            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "'POST','OPTIONS','GET'",
            },
          })
          .then((response) => {
            setLoaderstate(false);
            const userdata = eval(response.data.d);
            setInvoicelList(userdata);
            handleUncheckedSingleFinal("", singleInvoiceId);
            setInvreason("");
          })
          .catch((error) => {
            console.log("API error", error);
            setInvreason("");
          });
      }
    } catch (error) {
      console.log(error);
    }
  };
  //Unckeck Reason Model start

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ flexGrow: 1 }} style={{ display: "block" }}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: "10px", paddingLeft: "10px" }}
          >
            <Grid item xs={1}>
              <Button variant="contained" onClick={handleUpdateSelected}>
                Confirm
              </Button>
            </Grid>
            <Grid item xs={2}>
              <h2>Invoice List </h2>
            </Grid>

            <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            />

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: "24px",
                fontWeight: "bolder",
                color: "red",
              }}
            >
              {loaderstate === false && invoicelist && invoicelist.length === 0
                ? "Sorry there is no records"
                : ""}
            </Box>

            <Grid item xs={2}>
              <Button
                variant="contained"
                onClick={() => handleAddExtraChargePopup()}
              >
                Add Extra Charges
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedCustomerIds.length === invoicelist.length}
                    color="primary"
                    indeterminate={
                      selectedCustomerIds.length > 0 &&
                      selectedCustomerIds.length < invoicelist.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell>Invoice No</TableCell>
                <TableCell>Details</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Total Extra Charges</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
                <TableCell> Delivery Type</TableCell>
                {/* <TableCell> Edit Amount</TableCell> */}
                <TableCell> Confirm</TableCell>
                <TableCell> Extra Charges </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicelist &&
                invoicelist.length > 0 &&
                invoicelist
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((customer, index) => (
                    <TableRow hover key={index[0]}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={customer.confirmnot === "Yes"}
                          onClick={(event) =>
                            handleSelectSingle(
                              event,
                              customer.InvoiceNo,
                              customer.SNOTR
                            )
                          }
                        />
                        {customer.confirmnot === "Yes" && (
                          <UndoIcon
                            style={{ cursor: "pointer", marginLeft: "8px" }}
                            onClick={(event) =>
                              handleUncheckedSingle(
                                event,
                                customer.InvoiceNo,
                                customer.SNOTR
                              )
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        {customer.InvoiceNo.split(",").reduce((all, cur) => [
                          ...all,
                          <br />,
                          cur,
                        ])}
                      </TableCell>

                      {customer.Del_type == "D4" ? (
                        <TableCell>Stock Transfer</TableCell>
                      ) : customer.Del_type == "O1" ? (
                        <TableCell>Other</TableCell>
                      ) : (
                        <TableCell>
                          {customer.inv_address}
                          <br />
                          {customer.inv_email}
                          <br />
                          {customer.inv_mobile && (
                            <>
                              {customer.inv_mobile} <br />
                            </>
                          )}
                          {customer.Inv_phone && (
                            <>
                              {customer.Inv_phone}
                              <br />
                            </>
                          )}
                          {customer.inv_state}
                        </TableCell>
                      )}

                      <TableCell> {`$ ${customer.Amount}`} </TableCell>
                      <TableCell>
                        {" "}
                        {`$ ${customer.Total_Extracharge}`}{" "}
                      </TableCell>
                      <TableCell> {customer.Status} </TableCell>
                      <TableCell> {customer.DeliveryDate} </TableCell>
                      <TableCell>{customer.Delivery_Type}</TableCell>

                      {/* <TableCell>
                                            <TableCell
                                                onClick={
                                                    (event) =>
                                                        handleOpen(
                                                            event,
                                                            customer,
                                                            'remarks'
                                                        )
                                                }
                                            >
                                                <EditIcon />
                                            </TableCell>
                                        </TableCell> */}

                      {/* <TableCell>
                                            {customer.Status === 'Unconfirmed' ? (
                                                <Button
                                                    // variant="contained"
                                                    color="primary"
                                                    size="medium"
                                                    onClick={
                                                        (event) =>
                                                            handleOpen(
                                                                event,
                                                                customer,
                                                                'remarks'
                                                            )
                                                    }
                                                >
                                                    <EditIcon />
                                                </Button>
                                            ) : (
                                                <Button
                                                    // variant="contained"
                                                    color="primary"
                                                    size="medium"
                                                    disabled
                                                >
                                                    <EditIcon1 />
                                                </Button>
                                            )}
                                        </TableCell> */}

                      <TableCell>
                        {customer.Status === "Unconfirmed" ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() => handleConfirmEditExcel(customer)}
                          >
                            Confirm
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            disabled
                          >
                            Confirm
                          </Button>
                        )}
                      </TableCell>

                      <TableCell>
                        {customer.Status !== "Unconfirmed" ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() =>
                              handleOpenEdit(
                                customer.InvoiceNo,
                                customer.DeliveryDate,
                                customer.Inv_delcharge,
                                customer.Status,
                                customer.SNOTR
                              )
                            }
                          >
                            View
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() =>
                              handleOpenEdit(
                                customer.InvoiceNo,
                                customer.DeliveryDate,
                                customer.Inv_delcharge,
                                customer.Status,
                                customer.SNOTR
                              )
                            }
                          >
                            Extra Charges
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>

            <TableRow>
              <TableCell colSpan={13}>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100, 200]}
                  component="div"
                  count={invoicelist.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableCell>
            </TableRow>
          </Table>
        </Box>
      </PerfectScrollbar>

      <Modal
        open={openEditFirst}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{
          width: "800%",
          maxWidth: "none",
          backgroundColor: "#dcdcdc",
        }}
      >
        <Box sx={styletable} className="InvoicePopup">
          <Typography id="modal-modal-title" variant="h5" component="h5">
            Invoice No. {editInvoiceData}
          </Typography>
          <div className="SectionOne">
            <Typography id="modal-modal-title" variant="h3" component="h3">
              Delivery charge amount
            </Typography>
            <Typography id="modal-modal-title" variant="h3" component="h3">
              {invoiceAmount && invoiceAmount}
            </Typography>
          </div>

          <Grid container style={{ padding: "0px 20px" }}>
            <Grid item xs={8} style={{ backgroundColor: "#fff" }}>
              <Box sx={{ minWidth: 550 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "#fff",
                    padding: "20px 20px",
                  }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={3}>
                        {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
                          <FormControl fullWidth size="small">
                            <InputLabel
                              id="demo-simple-select-label"
                              style={{ margin: "0px 0px 0px 32px" }}
                            >
                              Select value
                            </InputLabel>

                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={editInvoiceDate}
                              label="Select value"
                              onChange={handleChangeselect}
                            >
                              {/* <MenuItem value={0}>Truck Hire</MenuItem> */}
                              {/* <MenuItem value={1}>Labour Hire</MenuItem>
                                                            <MenuItem value={2}>Other</MenuItem> */}
                              {/* <MenuItem value={0}>Truck Hire(4T)</MenuItem>
                                                            <MenuItem value={1}>Truck Hire(6T)</MenuItem>
                                                            <MenuItem value={2}>Truck Hire(10T)</MenuItem>
                                                            <MenuItem value={3}>Truck Hire(Van)</MenuItem>
                                                            <MenuItem value={4}>Labour Hire</MenuItem> */}
                              <MenuItem value={5}>Other</MenuItem>
                              <MenuItem value={6}>Cancelling</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          <FormControl fullWidth size="small" disabled>
                            <InputLabel
                              id="demo-simple-select-label"
                              style={{ margin: "0px 0px 0px 32px" }}
                            >
                              Select value
                            </InputLabel>

                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={editInvoiceDate}
                              label="Select value"
                              onChange={handleChangeselect}
                            >
                              <MenuItem value={0}>Truck Hire</MenuItem>
                              <MenuItem value={1}>Labour Hire</MenuItem>
                              <MenuItem value={2}>Other</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </Grid>

                      <Grid item xs={3}>
                        {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
                          <TextField
                            label="Extra charge amount"
                            size="small"
                            id="outlined-start-adornment"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }}
                            placeholder="Amount"
                            value={insertPrice}
                            onChange={handleInsertPrice}
                          />
                        ) : (
                          <TextField
                            label="Extra charge amount"
                            size="small"
                            id="outlined-start-adornment"
                            disabled
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }}
                            placeholder="Amount"
                            // value={insertPrice}
                            // onChange={handleInsertPrice}
                          />
                        )}
                      </Grid>
                      <Grid item xs={2}>
                        <Typography id="modal-modal-footer">
                          {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
                            <Button
                              variant="contained"
                              onClick={handleInserNewData}
                            >
                              ADD
                            </Button>
                          ) : (
                            <Button variant="contained" disabled>
                              ADD
                            </Button>
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </div>
                <TableContainer sx={{ maxHeight: 440 }}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    style={{ padding: "0px 8px" }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Amount($)</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Action</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell> {}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deliveryEditData &&
                        deliveryEditData.length > 0 &&
                        deliveryEditData.map((customer) => (
                          <TableRow hover>
                            <TableCell> {customer.Ec_Description} </TableCell>
                            <TableCell> {customer.Ec_Amount} </TableCell>
                            <TableCell> {customer.Column2} </TableCell>
                            <TableCell>
                              {" "}
                              {customer.Status === "1"
                                ? "Approve"
                                : "Unapproved"}{" "}
                            </TableCell>

                            <TableCell>
                              {invoiceStatus &&
                              invoiceStatus === "Unconfirmed" ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="medium"
                                  onClick={() => handleDeleteData(customer)}
                                >
                                  Delete
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="medium"
                                  onClick={() => handleDeleteData(customer)}
                                  disabled
                                >
                                  Delete
                                </Button>
                              )}
                            </TableCell>
                            <TableCell> {} </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            <Grid item xs={4} style={{ paddingLeft: "10px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  padding: "20px 20px",
                }}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
                        <TextField
                          fullWidth
                          id="outlined-multiline-static"
                          label="Comment"
                          multiline
                          rows={5}
                          value={invremarks}
                          columns={20}
                          onChange={handleRemarksChange}
                        />
                      ) : (
                        <TextField
                          fullWidth
                          id="outlined-multiline-static"
                          label="Comment"
                          multiline
                          disabled
                          rows={5}
                          defaultValue={invremarks}
                          columns={20}
                          onChange={handleRemarksChange}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "right" }}>
                      <Typography id="modal-modal-footer">
                        {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
                          <Button variant="contained" onClick={handleRemarks}>
                            Add Comment
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            onClick={handleRemarks}
                            disabled
                          >
                            Add Comments
                          </Button>
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </div>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sent By</TableCell>
                      <TableCell>Comments</TableCell>
                      <TableCell>Created Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {responseForComment &&
                      responseForComment.length > 0 &&
                      responseForComment.map((customer) => (
                        <TableRow hover>
                          <TableCell> {customer.createdbyname} </TableCell>
                          <TableCell> {customer.Comment} </TableCell>
                          <TableCell> {customer.createddate} </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          <div className="PopupFooter">
            {invoiceStatus && invoiceStatus === "Unconfirmed" ? (
              <Button
                variant="outlined"
                style={{ margin: "0px 4px 0px 0px" }}
                onClick={handleOnOkay}
              >
                OK
              </Button>
            ) : (
              <Button
                variant="outlined"
                style={{ margin: "0px 4px 0px 0px" }}
                onClick={handleClose}
              >
                CANCEL
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      {/* Uncheck reason model */}
      <Modal
        open={openunchecked}
        onClose={handleCloseUnchecked}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Reason"
              multiline
              rows={8}
              defaultValue={invremarks}
              columns={20}
              onChange={handleReasonChange}
            />
            {errormsg && (
              <Typography sx={istyle}>Please enter reason </Typography>
            )}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button variant="contained" onClick={handleReason}>
              Save Reason
            </Button>

            <Button
              style={{ marginLeft: "5px" }}
              variant="contained"
              onClick={handleCloseUnchecked}
            >
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Amount"
              defaultValue={oldAmount}
              onChange={handleAmount}
            />

            {errorMessage && (
              <Typography sx={istyle}>
                {errorMessage && errorMessage}{" "}
              </Typography>
            )}
          </Typography>

          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              style={{ marginRight: "10px" }}
              onClick={handleSaveAmount}
            >
              Save Amount
            </Button>

            <Button variant="contained" onClick={handleCloseAmount}>
              Close
            </Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={mainPoupDiv}
        onClose={handleCloseMainPoupDiv}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CancelIcon
            onClick={handleCloseMainPoupDiv}
            sx={{
              position: "absolute",
              top: 7,
              right: 7,
              fontSize: "24px",
              cursor: "pointer",
              "&:hover": {
                color: "primary.main",
              },
            }}
          />

          <Typography
            id="modal-modal-description"
            sx={{
              fontWeight: "600",
              textTransform: "uppercase",
              textAlign: "center",
              mb: 4,
            }}
          >
            {`add extra charges`}
          </Typography>
          <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => handleOpenTipRunPopup(1)}
                sx={{ mr: 3, width: "150px" }}
              >
                Tip Run
              </Button>

              <Button
                variant="contained"
                onClick={() => handleOpenTipRunPopup(2)}
                sx={{ mr: 3, width: "150px" }}
              >
                Line Haul Fee
              </Button>

              <Button
                variant="contained"
                onClick={() => handleOpenTipRunPopup(3)}
                sx={{ mr: 3, width: "150px" }}
              >
                Other
              </Button>
            </Box>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openTipRunPopup}
        onClose={(e) => handleCloseAddExtraChargePopup(e)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, fontWeight: "600", textTransform: "uppercase" }}
          >
            {`add extra charges for ${
              addExtraCharges.poupType == 1
                ? "tip run"
                : addExtraCharges.poupType == 2
                ? "line haul fees"
                : "Other"
            }`}
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Amount"
              type="number"
              multiline
              rows={1}
              defaultValue={invremarks}
              columns={2}
              onChange={handleAmountChange}
            />
            {errormsg && (
              <Typography sx={{ color: "red" }}>
                Please enter a valid number
              </Typography>
            )}
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Comment"
              multiline
              rows={1}
              defaultValue={invremarks}
              columns={2}
              onChange={(event) =>
                setAddExtraCharges({
                  ...addExtraCharges,
                  cmt: event.target.value,
                })
              }
            />
            {errorMsgForComment && (
              <Typography sx={istyle}>Please enter comment </Typography>
            )}
          </Typography>

          <Typography id="modal-modal-footer" sx={{ mt: 4, ml: 36 }}>
            {addExtraCharges.amt != 0 &&
              addExtraCharges.cmt != "" &&
              !errormsg &&
              !errorMsgForComment && (
                <Button
                  variant="contained"
                  onClick={() => handleAddExtraCharges()}
                >
                  + Add
                </Button>
              )}
          </Typography>
        </Box>
      </Modal>

      <Snackbar
        open={sneakOpen}
        autoHideDuration={3000}
        onClose={handleCloseSneakBar}
      >
        <Alert
          onClose={handleCloseSneakBar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {/* {sneakBarMessage && sneakBarMessage} */}
          its working
        </Alert>
      </Snackbar>

      <Snackbar
        open={sneakOpenFrComment}
        autoHideDuration={3000}
        onClose={handleCloseCommentSneakbar}
      >
        <Alert
          onClose={handleCloseCommentSneakbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {sneakBarCommentMessage && sneakBarCommentMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

InvoiceDetailResult.propTypes = {
  customers: PropTypes.array.isRequired,
};

export default InvoiceDetailResult;
